import Individual from './individual/Channel';
import List from './list/Channels';

export default { List, Individual };
